import React, { createContext, useEffect, useState } from "react";

// Despite the name (kept to avoid touching every consumer), this no longer
// tracks the old left sidebar — it's now TopNav's mobile off-canvas menu
// open/closed state. isSidebarOpen === the mobile menu being open.
interface SidebarContextProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextProps>({
  isSidebarOpen: false,
  toggleSidebar: () => {},
});

// Must match the top-navbar's own CSS breakpoint (public/assets/css/style.css)
// where it switches to the stacked mobile menu.
const MOBILE_BREAKPOINT = 1440;
const isMobileViewport = () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT;

export const SidebarProvider: React.FC<any> = ({ children }) => {
  // Computed from the real viewport at mount, not hardcoded true — a fresh
  // page load on an actual phone shouldn't paint with the whole stacked
  // mobile menu already expanded over the page.
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => !isMobileViewport());

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(!isMobileViewport());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
